import { storefrontApi } from "@app/lib/storefrontApi";
import Cookies from "js-cookie";

export const createCustomerAccessToken = async (email: string, password: string) => {
  const res = await storefrontApi(
    `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerUserErrors {
          code
          message
          field
        }
        customerAccessToken {
          accessToken
        }
      }
    }
  `,
    {
      input: {
        email,
        password,
      },
    },
  );

  if (res.customerAccessTokenCreate.customerAccessToken) {
    Cookies.set("customerAccessToken", res.customerAccessTokenCreate.customerAccessToken.accessToken);
  }

  return res.customerAccessTokenCreate;
};

export const createCustomer = async (data: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  acceptsMarketing: boolean;
}) => {
  const res = await storefrontApi(
    `
    mutation customerCreate($input: CustomerCreateInput!) {
      customerCreate(input: $input) {
        customer {
          firstName
          lastName
          email
          phone
          acceptsMarketing
        }
        customerUserErrors {
          field
          message
          code
        }
      }
    }
  `,
    {
      input: {
        ...data,
      },
    },
  );

  return res.customerCreate;
};

export const recoverCustomer = async (data: { email: string }) => {
  const res = await storefrontApi(
    `
    mutation customerRecover($email: String!) {
      customerRecover(email: $email) {
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `,
    {
      ...data,
    },
  );

  return res.customerRecover;
};
